import {
  faBell,
  faCommentDots,
  faWandMagic,
  faShieldCross,
  faUserClock,
  faBatterySlash,
} from "../../assets/consts/faCharCodes";

class UserMessage {
  constructor() {
    this.id = "";
    this.date = new Date();
    this.dateString = "";
    this.seen = false;
    this.title = "";
    this.body = "";
    this.channelId = "";
    this.payload = null;
    this.messageType = UserMessage.MESSAGE_TYPES.general;
    this.messageLevel = UserMessage.MESSAGE_LEVELS.info;

    this.getIcon = () => {
      switch (this.messageType) {
        case UserMessage.MESSAGE_TYPES.breach:
          return faShieldCross;
        case UserMessage.MESSAGE_TYPES.doorbell:
          return faBell;
        case UserMessage.MESSAGE_TYPES.guestExpire:
          return faUserClock;
        case UserMessage.MESSAGE_TYPES.scenarioReport:
          return faWandMagic;
          case UserMessage.MESSAGE_TYPES.lowBattery:
            return faBatterySlash;
        case UserMessage.MESSAGE_TYPES.general:
        default:
          return faCommentDots;
      }
    };
  }

  static MESSAGE_TYPES = {
    general: 0,
    doorbell: 1,
    guestExpire: 2,
    breach: 3,
    scenarioReport: 4,
    lowBattery: 5,
  };

  static MESSAGE_LEVELS = {
    info: 0,
    warning: 1,
    danger: 2,
  };

  static parse = (obj) => {
    if (!obj) return null;
    try {
      var result = new UserMessage();
      Object.assign(result, obj);
      return result;
    } catch (e) {
      return null;
    }
  };
}

export default UserMessage;
